import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
// import {history } from './../routers/Router';
// import createHistory from 'history/createBrowserHistory';
import utf8 from 'utf8';
import ErrorText from '../ErrorText';
import '../css/EditChannel.css';
import uniqid from 'uniqid';

//edit channel current immplementation

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 4,
    width: '60vw',
  },
});


class EditChannelNew extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: false,
    channelName: '',
    channelNumber: '',
    ChannelArray: '',
    ChannelGenre: '',
    ChannelLogoUrl: '',
    ChannelLogoBase64: '',
    editButtonDisable: true,
    editByChannelName: true,
    showErrorMessage: false,
    someData: [],
    channelNo: '',
  };
  this.closeModal = this.closeModal.bind(this);
}

closeModal() {
  this.setState({
    modalIsOpen: false
  });
  window.location.href ='/ai/addchannel';
}

componentWillMount(){
  let locationParameter = window.location.search;
  let searchingType =  locationParameter.substring(1,2);
  let searchOption  =  locationParameter.slice(2);
  searchOption = decodeURIComponent(searchOption);

  if(searchingType==='0'){
    this.setState({
      editByChannelName: false,
      channelNumber: searchOption
    })
  }else{
    this.setState({
      channelName: searchOption,
      editByChannelName: true
    })
  }
}



componentDidMount(){
  console.log('called from edit channel')
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  var bodyForChange;
  var cardstest = this.state.channelName;
  var cardschannelnumbertest = this.state.channelNumber;
  if(this.state.editByChannelName){
    bodyForChange = JSON.stringify({
      cardstest,
    })
  }else{
    bodyForChange = JSON.stringify({
      cardschannelnumbertest,
    })
  }
  fetch('/cloud/d2heditdata/' ,{
    method: "POST",
    headers: headers,
    body: bodyForChange
})
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  console.log(data)
  this.fetchChannelDetails(data)
  this.setState({
    someData: data
  })
})
.catch((err)=>{
  console.log(err)

})
}




onEdit = (e) => {
  var tokenStored = localStorage.getItem('token');

  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  var bodyForChange = JSON.stringify({
    channel_name: this.state.channelName,
    channel_Number: this.state.channelNumber,
    channel_Array: this.state.ChannelArray,
    logo: utf8.encode(this.state.ChannelLogoUrl.toString()),
    genre: this.state.ChannelGenre,
  })
  console.log(bodyForChange);
  console.log(this.state.someData[0].ID)
  fetch(`/cloud/updated2h/${this.state.someData[0].ID}` ,{
    method: "PUT",
    headers: headers,
    body: bodyForChange
})
.then(response => {
  console.log(response);
  if(response.status==200){
    this.setState({
      modalIsOpen: true
    })
  }else{
    alert('Action not completed.');
    // const history = createHistory({forceRefresh: true})
    window.location.href ='/ai/addchannel';
  }
})
.catch((err)=>{
  console.log(err)

})
}

onEditClick = () => {
  console.log('called 1')
  this.setState({
    showErrorMessage: true
  },()=>{
    this.fetchError((e)=>{
     if(e==='NoError'){
       this.onEdit();
     }
    })
  })
}

onReset = () => {
  if(this.state.editByChannelName){
    this.setState({
      channelNumber: '',
      ChannelArray: '',
      ChannelGenre: '',
      ChannelLogoUrl: '',
      editButtonDisable: true,
    })
  }else{
    this.setState({
      channelName: '',
      ChannelGenre: '',
      ChannelLogoUrl: '',
      editButtonDisable: true,
    })
  }
}




enableEditButton = () => {
  if(this.state.channelName==='' &&
     this.state.channelNumber==='' &&
     this.state.ChannelArray==='' &&
     this.state.ChannelGenre==='' &&
     this.state.ChannelLogoUrl===''    
  ){
    this.setState({
      editButtonDisable: true
    })
  }else{
    this.setState({
      editButtonDisable: false
    })
  }
}

fetchChannelDetails = (data) => {
  console.log(data)

  this.imgUrlToBase64(data[0].logo);
  this.setState({
    channelName: data[0].channel_name,
    channelNumber: data[0].channel_Number,
    ChannelArray: data[0].channel_Array,
    ChannelGenre: data[0].genre,
    // ChannelLogoUrl: data[0].logo,
  })
}


 getBase64 = (event) => {
 var input = event.target;
console.log(event.target)
  var reader = new FileReader();
  reader.onload = () => {
    this.setState({
      ChannelLogoUrl: reader.result,
      editButtonDisable: false
    },()=>{
      console.log(this.state.ChannelLogoUrl)
    })
  }
  reader.readAsDataURL(input.files[0]);  
};


toDataURL =(url, callback) => {
  var httpRequest = new XMLHttpRequest();
  httpRequest.onload = function() {
     var fileReader = new FileReader();
        fileReader.onloadend = function() {
           callback(fileReader.result);
        }
        fileReader.readAsDataURL(httpRequest.response);
  };
  httpRequest.open('GET', url);
  httpRequest.responseType = 'blob';
  httpRequest.send();
}

imgUrlToBase64 =(url) =>{
  console.log(url)
  url= `/media/${url}`;
  this.toDataURL(url, (dataUrl) => {
    console.log(dataUrl);
    this.setState({
      ChannelLogoUrl: dataUrl,
    },()=>console.log(this.state))
   })  
}


fetchError = (noError) => {
  var totalError = 4;
  if(ErrorText('isChannelName', this.state.channelName.trim())==='No Error'){
    totalError=totalError-1;
  } 
  if(ErrorText('isChannel', this.state.channelNumber)==='No Error'){
    totalError=totalError-1;
  } 
  if(ErrorText('notEmpty', this.state.ChannelGenre.trim())==='No Error'){
    totalError=totalError-1;
  } 
  if(ErrorText('notEmpty', this.state.ChannelLogoUrl.trim())==='No Error'){
    totalError=totalError-1;
  }
  if(totalError===0){
    noError('NoError');
  }  
  }

    render(){
        const { classes } = this.props;
        return (        
          <React.Fragment>
          <div style={{ width: '100%', paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px' }}>
            <div style={{ marginBottom: '20px' }}>
              <span style={{ color: '#888888', fontSize: '30px',marginLeft: '0px' }} className="text-uppercase"> Enter new details for Channel to be edited</span>
            </div>
            <div className="row">
              <div className="col-6">              
              <div className="group">
                 <input type="text" name="channelName" ref="channelName" className="row-edit" style={{backgroundColor: 'transparent'}}
                   value={this.state.channelName}
                   onChange={(e) => {
                                      if(!this.state.editByChannelName){
                        if(e.target.value.length<=40){
                          this.setState({
                            channelName: e.target.value
                          },()=>this.enableEditButton())                                            
                        }
                      }
                   }
                 }                 
                   required/>
                 <span className="highlight"></span>
                 <span className="bar"></span>
                 <label>Channel Name</label>
                 <span className="error text-danger" style={{fontSize: '.75rem'}}>{ErrorText('isChannelName', this.state.channelName.trim())!=='No Error' &&  this.state.showErrorMessage ? 'Invalid channel name' : ''}</span>
              </div>                  
                <div className="group ">
                   <input type="text" name="channelNumber" ref="channelNumber" className="row-edit" style={{backgroundColor: 'transparent'}}
                     value={this.state.channelNumber}
                     onChange={(e) => {
                       if(this.state.editByChannelName){
                        var str = e.target.value.toString().trim();
                        if(str.length<=4 && !isNaN(str)){
                          if(str.length==3){
                          str = `0${str}`
                        }else if(str.length==2){
                          str = `00${str}`
                        }else if(str.length==1){
                          str = `000${str}`
                        }
                        let res = str.split("");
                        res = `[${res}]`;                          
                         this.setState({
                           channelNumber: e.target.value,
                           channelNo: str,
                           ChannelArray: str
                          },()=>this.enableEditButton())}                      
                        }
                     }
                   }
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Number</label>
                   <span className="error text-danger" style={{fontSize: '.75rem'}}>{ErrorText('isChannel', this.state.channelNumber)!=='No Error' &&  this.state.showErrorMessage ? 'Invalid channel number' : ''}</span>
                </div>   
                <div className="group disableEvent">
                   <input type="text" name="ChannelArray" ref="ChannelArray" className="row-edit" style={{backgroundColor: 'transparent'}}
                     value={this.state.ChannelArray}
                     onChange={(e) => {
                       this.setState({
                         ChannelArray: e.target.value
                       })                       
                     }
                   }
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Array</label>
                </div>             
                <div className="group">
                   <input type="text" name="ChannelGenre" ref="ChannelGenre" className="row-edit" style={{backgroundColor: 'transparent'}}
                     value={this.state.ChannelGenre}
                     onChange={(e) => {
                       if(e.target.value.length<=40){
                         this.setState({
                           ChannelGenre: e.target.value
                          })
                        }
                     }
                   }
                     required/>
                   <span className="highlight"></span>
                   <span className="bar"></span>
                   <label>Channel Genre</label>
                   <span className="error text-danger" style={{fontSize: '.75rem'}}>{ErrorText('notEmpty', this.state.ChannelGenre.trim())!=='No Error' &&  this.state.showErrorMessage ? 'Genre must not be empty' : ''}</span>
                </div>     
                <div className="" key={uniqid()}>       
                  <input type='file' accept=".jpg,.png" onChange={this.getBase64.bind(this)} />              
                </div>             
              </div>     
              <div className="col-4 image-position m-3">
              <img src={this.state.ChannelLogoUrl}  id={uniqid()}/>              
              </div> 
              </div>
              <div className="swubmitbutton"> 
              <Link to='/ai/addchannel' >
                <div className="btn reset-btn mx-2 px-5">Cancel </div>
              </Link>
                <div className="btn add-new-btn mx-2 px-5" onClick={this.onReset.bind(this)} >Reset</div>
                <button className="btn edit-btn px-5 button-disabled" onClick={this.onEditClick.bind(this)}>Confirm Edit</button>
              </div>
          </div>  
          <Modal
                 isOpen={this.state.modalIsOpen}
                 onRequestClose={this.closeModal}
                 style={customStyles}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModal}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Thanks for Updation</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <Link to='/ai/dashboard'>
                <div className="btn reset-btn mx-2 px-5" >AI Dashboard </div>
                </Link>
                <Link to="/ai/addchannel">
                <div className="btn add-new-btn mx-2 px-5">Edit Another One</div>
                </Link>
            </div>
            </Modal>
        </React.Fragment>
        );
    }
}


EditChannelNew.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default styled(styles)(EditChannelNew);
